import { RuleObject } from 'antd/lib/form';
import React from 'react';

import TranslateText from 'components/hoc/TranslateText';

import { emailRegExp } from 'enums/regExp';

export const emailValidation = () => [
    () => ({
        validator(_rule: RuleObject, value: string) {
            if (value && (value.match(/@/g) || []).length > 1)
                return Promise.reject(<TranslateText>NEVALIDNI_EMAIL_TWO</TranslateText>);
            if (!value || emailRegExp.test(value)) return Promise.resolve();
            return Promise.reject(<TranslateText>NEVALIDNI_EMAIL</TranslateText>);
        }
    })
];

export default emailValidation;
